import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { APP_MOCKUP } from "../../lib/data";
import { useLanguage } from "../../lib/i18n";

const EASE = [0.16, 1, 0.3, 1];

export const Manifesto = () => {
  const { t } = useLanguage();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], [80, -80]);

  const chapters = t("manifesto.chapters");
  const nums = ["01", "02", "03"];

  return (
    <section id="manifesto" ref={ref} className="relative py-24 md:py-36 bg-[#060B18]" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.span initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} className="text-xs uppercase tracking-[0.2em] text-blue-400 font-bold">
          {t("manifesto.label")}
        </motion.span>

        <div className="grid lg:grid-cols-12 gap-12 mt-12 items-start">
          <div className="lg:col-span-7 space-y-20 md:space-y-28">
            {chapters.map((c, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.9, ease: EASE }}
                className="grid grid-cols-1 md:grid-cols-12 gap-6 items-start"
                data-testid={`manifesto-chapter-${nums[i]}`}
              >
                <div className="md:col-span-3">
                  <span className="font-head font-thin text-7xl md:text-8xl text-transparent [-webkit-text-stroke:1px_rgba(148,163,184,0.4)]">{nums[i]}</span>
                </div>
                <div className="md:col-span-9">
                  <h3 className="font-head text-3xl md:text-4xl tracking-tight leading-[1.15] mb-5">{c.title}</h3>
                  <p className="text-lg text-slate-400 leading-relaxed max-w-lg">{c.body}</p>
                </div>
              </motion.div>
            ))}
          </div>

          <div className="lg:col-span-5 hidden lg:block sticky top-32">
            <div className="relative rounded-[2rem] overflow-hidden border border-white/[0.06]">
              <div className="absolute inset-0 bg-blue-500/10 blur-2xl" />
              <motion.img style={{ y: imgY }} src={APP_MOCKUP} alt="Rexx Calling focused interface" className="relative w-full scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#060B18] via-transparent to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
